import type { ApiUser } from '~/api/types';

/**
 * The current user state
 */
export type CurrentUserState = ApiUser | null;

export const initialStateCurrentUser: CurrentUserState = null;
